import { render, staticRenderFns } from "./ClearDBCache.vue?vue&type=template&id=9b4b54ec&scoped=true"
import script from "./ClearDBCache.vue?vue&type=script&lang=js"
export * from "./ClearDBCache.vue?vue&type=script&lang=js"
import style0 from "./ClearDBCache.vue?vue&type=style&index=0&id=9b4b54ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4b54ec",
  null
  
)

export default component.exports